<template>
  <div>
    <Navbar activeDirectory="admin" activePage="admin-team-types"></Navbar>
    <div class="container-fluid py-4">
      <div class="row text-left">
        <div class="col-12">
          
          <!-- Page Header -->
          <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap">
            <div class="d-flex align-items-center">
              <div class="au-header-icon mr-3">
                <i class="mdi mdi-account-multiple"></i>
              </div>
              <div class="text-left">
                <h3 class="mb-0 font-weight-bold text-dark">Tipologie Squadra</h3>
                <p class="mb-0 text-muted small">Gestisci e crea le tipologie di squadra aziendali per i diversi moduli del sistema</p>
              </div>
            </div>
            <button 
              v-if="mode === 'list' && selectedCompanyId" 
              class="au-btn-submit" 
              @click="setAddMode"
            >
              <i class="mdi mdi-plus mr-1"></i> Aggiungi Tipologia
            </button>
          </div>

          <!-- Developer Company Selector -->
          <div class="au-card mb-4" v-if="tipologia === 'D' && mode === 'list'">
            <div class="row align-items-center">
              <div class="col-md-6">
                <label class="cw-label mb-2">Seleziona Azienda per gestire le tipologie</label>
                <div class="cw-select-wrap">
                  <i class="mdi mdi-domain cw-field-icon"></i>
                  <select v-model="selectedCompanyId" class="cw-select" @change="onCompanyChange">
                    <option :value="null">-- Seleziona Azienda --</option>
                    <option v-for="c in companies" :key="c.id" :value="c.id">
                      {{ c.nome }}
                    </option>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!selectedCompanyId && mode === 'list'" class="text-center py-5">
            <i class="mdi mdi-domain text-muted mb-3 d-block" style="font-size: 3rem; opacity: 0.5;"></i>
            <h5 class="text-muted">Seleziona un'azienda per visualizzare le tipologie squadra.</h5>
          </div>

          <!-- LIST VIEW -->
          <div class="au-card" v-if="mode === 'list' && selectedCompanyId">
            <div class="cw-section-title">
              Elenco Tipologie Squadra
            </div>

            <!-- Search Bar -->
            <div class="mb-4" style="max-width:360px;">
              <div class="au-search-wrap">
                <i class="mdi mdi-magnify au-search-icon"></i>
                <input
                  v-model="searchQuery"
                  class="au-search-input"
                  placeholder="Cerca per nome o codice..."
                >
              </div>
            </div>

            <div class="table-responsive">
              <table class="au-table">
                  <thead>
                    <tr>
                      <th style="width: 80px;">ID</th>
                      <th>Nome Tipologia</th>
                      <th>Iniziali Username</th>
                      <th>Modulo Associato</th>
                      <th>Commessa Associata</th>
                      <th class="text-right" style="width: 140px;">Azioni</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loading">
                      <td colspan="6" class="text-center py-4">
                        <span class="spinner-border spinner-border-sm text-primary mr-2" role="status"></span>
                        Caricamento tipologie...
                      </td>
                    </tr>
                    <tr v-else-if="filteredTeamTypes.length === 0">
                      <td colspan="6" class="text-center py-5 text-muted">
                        <i class="mdi mdi-account-multiple d-block mb-2" style="font-size: 2.4rem; opacity:0.3;"></i>
                        <span class="font-weight-semibold d-block text-dark">Nessuna tipologia trovata</span>
                        Nessuna tipologia di squadra corrisponde ai criteri di ricerca.
                      </td>
                    </tr>
                    <tr v-for="t in filteredTeamTypes" :key="t.id" v-else>
                      <td class="font-weight-bold text-muted">#{{ t.id }}</td>
                      <td>
                        <div class="d-flex align-items-center">
                          <div class="as-teamtype-icon mr-3"><i class="mdi mdi-account-multiple"></i></div>
                          <span class="font-weight-bold text-dark">{{ t.nome }}</span>
                        </div>
                      </td>
                      <td>
                        <span class="au-role-badge au-role-admin font-monospace">
                          {{ t.codice }}
                        </span>
                      </td>
                      <td>
                        <span v-if="t.fk_module" class="au-company-badge">
                          <i class="mdi mdi-layers mr-1" style="font-size:0.75rem;"></i>
                          {{ getModuleName(t.fk_module) }}
                        </span>
                        <span v-else class="text-muted small">—</span>
                      </td>
                      <td>
                        <span v-if="t.fk_commessa" class="au-company-badge">
                          <i class="mdi mdi-briefcase mr-1" style="font-size:0.75rem;"></i>
                          {{ getCommessaName(t.fk_commessa) }}
                        </span>
                        <span v-else class="text-muted small">—</span>
                      </td>
                      <td class="text-right text-nowrap">
                        <button 
                          class="au-btn-danger-sm"
                          @click="deleteTeamType(t)"
                        >
                          <i class="ti-trash mr-1"></i> Elimina
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
          </div>

          <!-- ADD VIEW -->
          <div class="row justify-content-center" v-if="mode === 'add'">
            <div class="col-lg-6 col-md-8 mb-4">
              <div class="au-card text-left">
                <div class="cw-section-title"><span class="cw-step-num">1</span>Nuova Tipologia Squadra Aziendale</div>
                  
                  <form @submit.prevent="saveTeamType">
                    <div class="form-group mb-3">
                      <label class="cw-label">Nome Tipologia *</label>
                      <div class="cw-input-wrap">
                        <i class="mdi mdi-text cw-field-icon"></i>
                        <input 
                          v-model="form.nome" 
                          class="cw-input" 
                          placeholder="Es. Manutenzione Fognature" 
                          required
                          @input="generateInitials"
                        >
                      </div>
                    </div>

                    <div class="form-group mb-3">
                      <label class="cw-label">Iniziali Username (2-3 caratteri) *</label>
                      <div class="cw-input-wrap">
                        <i class="mdi mdi-form-textbox cw-field-icon"></i>
                        <input 
                          v-model="form.codice" 
                          class="cw-input" 
                          placeholder="Es. MF" 
                          maxlength="4"
                          required
                        >
                      </div>
                      <small class="form-text text-muted mt-1">
                        Utilizzate per autogenerare l'username delle squadre. Esempio: <code>C1.squadra_a.MF</code>
                      </small>
                    </div>

                    <div class="form-group mb-3">
                      <label class="cw-label">Modulo Associato</label>
                      <div class="cw-select-wrap">
                        <i class="mdi mdi-layers cw-field-icon"></i>
                        <select v-model="form.fk_module" class="cw-select">
                          <option value="">-- Nessun Modulo --</option>
                          <option v-for="m in modules" :key="m.id" :value="m.id">
                            {{ m.nome }} ({{ m.codice }})
                          </option>
                        </select>
                        <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="cw-label">Commessa Associata</label>
                      <div class="cw-select-wrap">
                        <i class="mdi mdi-briefcase cw-field-icon"></i>
                        <select v-model="form.fk_commessa" class="cw-select">
                          <option value="">-- Nessuna Commessa --</option>
                          <option v-for="c in commesse" :key="c.id" :value="c.id">
                            {{ c.nome }}
                          </option>
                        </select>
                        <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                      </div>
                    </div>

                    <div class="cw-footer mt-4 d-flex justify-content-end align-items-center" style="gap: 8px;">
                      <button 
                        type="button" 
                        class="btn btn-light rounded-pill px-4 font-weight-semibold border" 
                        @click="mode = 'list'"
                      >
                        Annulla
                      </button>
                      <button 
                        type="submit" 
                        class="au-btn-submit"
                        :disabled="submitting"
                      >
                        <span class="spinner-border spinner-border-sm mr-2" v-if="submitting"></span>
                        <i class="mdi mdi-check-circle mr-1" v-else></i> Salva Tipologia
                      </button>
                    </div>
                  </form>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";

export default {
  name: "AdminTeamTypes",
  components: {
    Navbar
  },

  data() {
    return {
      tipologia: localStorage.getItem("tipologia"),
      myCompanyId: parseInt(localStorage.getItem("fk_company")) || null,
      mode: "list", // 'list', 'add'
      
      selectedCompanyId: null,
      companies: [],
      
      teamTypes: [],
      modules: [],
      commesse: [],
      searchQuery: "",
      
      loading: false,
      submitting: false,

      form: {
        nome: "",
        codice: "",
        fk_module: "",
        fk_commessa: ""
      }
    };
  },

  computed: {
    filteredTeamTypes() {
      if (!this.searchQuery || !this.searchQuery.trim()) {
        return this.teamTypes;
      }
      const term = this.searchQuery.trim().toLowerCase();
      return this.teamTypes.filter(t => {
        const nome = t.nome ? t.nome.toLowerCase() : "";
        const codice = t.codice ? t.codice.toLowerCase() : "";
        return nome.includes(term) || codice.includes(term);
      });
    }
  },

  mounted() {
    if (this.tipologia !== "D" && this.tipologia !== "B") {
      this.$router.push({ name: "home" });
      return;
    }

    if (this.tipologia === "D") {
      this.loadCompanies();
    } else {
      this.selectedCompanyId = this.myCompanyId;
      this.onCompanyChange();
    }
  },

  methods: {
    loadCompanies() {
      this.axios.get("/companies")
        .then((response) => {
          this.companies = Array.isArray(response.data) ? response.data : [];
        })
        .catch((err) => {
          console.error("Errore caricamento aziende:", err);
        });
    },

    onCompanyChange() {
      if (!this.selectedCompanyId) {
        this.teamTypes = [];
        this.modules = [];
        this.commesse = [];
        return;
      }
      this.loadTeamTypes();
      this.loadModules();
      this.loadCommesse();
    },

    loadTeamTypes() {
      this.loading = true;
      this.axios.get(`/companies/${this.selectedCompanyId}/tipologie-squadra`)
        .then((response) => {
          this.teamTypes = Array.isArray(response.data) ? response.data : [];
          this.syncTeamTypesToLocalStorage(this.teamTypes);
        })
        .catch((err) => {
          console.error("Errore caricamento tipologie squadra:", err);
          this.$swal.fire("Errore", "Impossibile caricare le tipologie di squadra.", "error");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    syncTeamTypesToLocalStorage(customTypes) {
      const defaultTeamTypes = [
        { value: "1", label: "Manutenzione stradale", module: "manutenzione_strade", initials: "MS" },
        { value: "2", label: "Manutenzione aree verdi", module: "verde_pubblico", initials: "MAV" },
        { value: "3", label: "Installazione impianto", module: "illuminazione", initials: "II" },
        { value: "4", label: "Riparazione guasti", module: "illuminazione", initials: "RG" },
        { value: "5", label: "Controllo impianti", module: "illuminazione", initials: "CI" },
        { value: "6", label: "Manutenzione ordinaria", module: "manutenzione_strade", initials: "MO" },
        { value: "7", label: "Gestione emergenza", module: "manutenzione_strade", initials: "GE" },
        { value: "8", label: "Pulizia e sanificazione", module: "pulizia_stradale", initials: "PP" },
        { value: "9", label: "Controllo qualità", module: "manutenzione_strade", initials: "CQ" }
      ];
      const mappedCustom = customTypes.map(t => ({
        value: String(t.id),
        label: t.nome,
        module: t.module_code || "",
        initials: t.codice || ""
      }));
      const merged = [...defaultTeamTypes, ...mappedCustom];
      localStorage.setItem("teamTypes", JSON.stringify(merged));
    },

    loadModules() {
      this.axios.get(`/companies/${this.selectedCompanyId}/modules`)
        .then((response) => {
          this.modules = Array.isArray(response.data) ? response.data : [];
        })
        .catch((err) => {
          console.error("Errore caricamento moduli:", err);
        });
    },

    loadCommesse() {
      this.axios.get(`/companies/${this.selectedCompanyId}/commesse`)
        .then((response) => {
          this.commesse = Array.isArray(response.data) ? response.data : [];
        })
        .catch((err) => {
          console.error("Errore caricamento commesse:", err);
        });
    },

    getModuleName(moduleId) {
      if (!moduleId) return "Nessuno";
      const found = this.modules.find(m => m.id === moduleId);
      return found ? found.nome : moduleId;
    },

    getCommessaName(commessaId) {
      if (!commessaId) return "Nessuna";
      const found = this.commesse.find(c => c.id === commessaId);
      return found ? found.nome : commessaId;
    },

    setAddMode() {
      this.form = {
        nome: "",
        codice: "",
        fk_module: "",
        fk_commessa: ""
      };
      this.mode = "add";
    },

    generateInitials() {
      if (!this.form.nome) {
        this.form.codice = "";
        return;
      }
      // Prendi le prime lettere di ciascuna parola (es. "Manutenzione Fognature" -> "MF")
      const words = this.form.nome.trim().split(/\s+/);
      let initials = words.map(w => w.charAt(0)).join("").toUpperCase();
      // Se è composta da una sola parola, prendi le prime 2-3 lettere
      if (words.length === 1 && this.form.nome.length >= 2) {
        initials = this.form.nome.substring(0, 2).toUpperCase();
      }
      this.form.codice = initials;
    },

    saveTeamType() {
      if (!this.form.nome.trim() || !this.form.codice.trim()) {
        this.$swal.fire("Attenzione", "Nome e Iniziali (Codice) sono obbligatori.", "warning");
        return;
      }

      this.submitting = true;
      const payload = {
        nome: this.form.nome.trim(),
        codice: this.form.codice.trim().toUpperCase(),
        fk_module: this.form.fk_module || null,
        fk_commessa: this.form.fk_commessa || null
      };

      this.axios.post(`/companies/${this.selectedCompanyId}/tipologie-squadra`, payload)
        .then((response) => {
          if (response.data && response.data.success) {
            this.$swal.fire("Successo!", "Nuova tipologia di squadra registrata.", "success");
            this.mode = "list";
            this.loadTeamTypes();
          } else {
            this.$swal.fire("Errore", response.data.error || "Impossibile salvare.", "error");
          }
        })
        .catch((error) => {
          console.error("Errore salvataggio tipologia:", error);
          this.$swal.fire("Errore", "Impossibile contattare il server.", "error");
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    deleteTeamType(t) {
      this.$swal.fire({
        title: "Sei sicuro?",
        text: `Vuoi disattivare la tipologia "${t.nome}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sì, disattiva!",
        cancelButtonText: "Annulla"
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete(`/companies/${this.selectedCompanyId}/tipologie-squadra/${t.id}`)
            .then((response) => {
              if (response.data && response.data.success) {
                this.$swal.fire("Disattivata!", "La tipologia è stata disattivata con successo.", "success");
                this.loadTeamTypes();
              } else {
                this.$swal.fire("Errore", response.data.error || "Impossibile disattivare.", "error");
              }
            })
            .catch(() => {
              this.$swal.fire("Errore", "Si è verificato un errore durante la disattivazione.", "error");
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.shadow-md {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}
.rounded-lg {
  border-radius: 12px;
}
.font-weight-semibold {
  font-weight: 500;
}
.badge-soft-primary {
  background-color: rgba(247, 147, 30, 0.1);
  color: #F7931E;
  border: 1px solid rgba(247, 147, 30, 0.2);
}
.badge-soft-success {
  background-color: rgba(16, 185, 129, 0.1);
  color: #059669;
  border: 1px solid rgba(16, 185, 129, 0.2);
}

/* Base tokens */
.cw-section-title {
  font-size: 0.82rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.08em;
  color: #64748b; margin-bottom: 22px;
  display: flex; align-items: center;
}
.cw-step-num {
  width: 22px; height: 22px; border-radius: 50%;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.7rem; font-weight: 800;
  display: inline-flex; align-items: center; justify-content: center;
  margin-right: 10px; flex-shrink: 0;
}
.cw-label {
  font-size: 0.75rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em;
  color: #94a3b8; margin-bottom: 8px; display: block;
}
.cw-input-wrap, .cw-select-wrap { position: relative; display: flex; align-items: center; }
.cw-field-icon {
  position: absolute; left: 12px;
  color: #94a3b8; font-size: 1rem; z-index: 2; pointer-events: none;
}
.cw-input, .cw-select {
  width: 100%; height: 46px; padding: 0 14px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; font-size: 0.92rem; font-weight: 500; color: #1e293b;
  transition: border-color 0.2s, box-shadow 0.2s; outline: none;
}
.cw-select {
  padding-right: 38px;
  appearance: none; -webkit-appearance: none; cursor: pointer;
}
.cw-input:focus, .cw-select:focus {
  border-color: #F7931E; box-shadow: 0 0 0 3px rgba(247,147,30,0.12); background: #fff;
}
.cw-select-arrow {
  position: absolute; right: 14px;
  color: #94a3b8; font-size: 1rem; pointer-events: none;
}
.cw-footer {
  background: #fff; border-radius: 14px;
  padding: 18px 24px; border: 1px solid rgba(0,0,0,0.05);
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* Admin UI standardized classes */
.au-header-icon {
  width: 48px; height: 48px; border-radius: 14px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 12px rgba(247,147,30,0.35); flex-shrink: 0;
}
.au-header-icon .mdi { color: #fff; font-size: 1.5rem; }

.au-card {
  background: #fff; border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  padding: 28px; border: 1px solid rgba(0,0,0,0.05);
}

.au-btn-submit {
  display: inline-flex; align-items: center;
  padding: 10px 24px; border: none; border-radius: 30px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.88rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 14px rgba(247,147,30,0.35);
  transition: all 0.2s;
}
.au-btn-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #E07B00, #C96A00);
  box-shadow: 0 6px 18px rgba(247,147,30,0.45); transform: translateY(-1px);
}
.au-btn-submit:disabled { opacity: 0.55; cursor: not-allowed; transform: none; }

.au-btn-action {
  display: inline-flex; align-items: center;
  padding: 6px 14px; border-radius: 20px; border: 1.5px solid #e2e8f0;
  background: #fff; color: #F7931E; font-size: 0.78rem; font-weight: 700;
  cursor: pointer; transition: all 0.15s;
}
.au-btn-action:hover { background: #FEF1E0; border-color: #F7931E; }

.au-btn-danger-sm {
  display: inline-flex; align-items: center;
  padding: 6px 14px; border-radius: 20px; border: 1.5px solid #fecaca;
  background: #fff5f5; color: #991b1b; font-size: 0.78rem; font-weight: 700;
  cursor: pointer; transition: all 0.15s;
}
.au-btn-danger-sm:hover { background: #fee2e2; border-color: #ef4444; }

/* Search bar */
.au-search-wrap {
  position: relative; display: flex; align-items: center;
  background: #f8fafc; border: 1.5px solid #e2e8f0;
  border-radius: 30px; height: 44px; padding: 0 16px 0 38px;
  transition: border-color 0.2s;
}
.au-search-wrap:focus-within { border-color: #F7931E; background: #fff; }
.au-search-icon { position: absolute; left: 14px; color: #94a3b8; font-size: 1rem; pointer-events: none; }
.au-search-input {
  border: none; background: transparent; outline: none;
  font-size: 0.9rem; color: #1e293b; width: 100%;
}

/* Badges */
.au-company-badge {
  display: inline-flex; align-items: center; background: #f1f5f9;
  color: #475569; border: 1px solid #e2e8f0; border-radius: 20px;
  padding: 3px 10px; font-size: 0.75rem; font-weight: 600;
}
.au-role-badge {
  display: inline-block; padding: 3px 10px; border-radius: 20px;
  font-size: 0.72rem; font-weight: 700; letter-spacing: 0.04em;
}
.au-role-admin { background: #FEF1E0; color: #E07B00; }

/* Team type row icon */
.as-teamtype-icon {
  width: 34px; height: 34px; border-radius: 9px;
  background: #FEF1E0; color: #F7931E;
  display: flex; align-items: center; justify-content: center;
  font-size: 1rem; flex-shrink: 0;
}

/* Table */
.au-table { width: 100%; border-collapse: collapse; }
.au-table thead tr { border-bottom: 2px solid #f1f5f9; }
.au-table thead th {
  padding: 10px 16px; font-size: 0.72rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em; color: #94a3b8; background: #f8fafc;
}
.au-table tbody tr { border-bottom: 1px solid #f1f5f9; transition: background 0.15s; }
.au-table tbody tr:hover { background: #f8fafc; }
.au-table td { padding: 14px 16px; vertical-align: middle; }

.font-monospace { font-family: 'SFMono-Regular', Consolas, monospace; }
</style>
